import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ['container']

  get languages() {
    return {
      en: {
        noneSelectedText: 'Nothing selected'
      },
      de: {
        noneSelectedText: 'Keine Auswahl'
      },
    }
  }

  connect() {
    let language = document.querySelector('html').getAttribute('lang')

    this.select = $(this.containerTarget).selectpicker({
      showTick: true,
      showSubtext: true,
      noneSelectedText: this.languages[language]['noneSelectedText'],
    });
  }

  disconnect() {
    this.select.selectpicker('destroy');
  }

  clear(event) {
    event.stopPropagation();
    this.select.selectpicker('val', ['']);
  }
}
